// Helper: get displayable location (zip code only, never full address)
export const getDisplayLocation = (location) => {
  if (!location) return 'Unknown';
  if (location.zipCode) return location.zipCode;
  // Fallback: try to extract zip code pattern from city string
  const match = location.address?.match(/\b(\d{5}(-\d{4})?)\b/);
  if (match) return match[1];
  return location.address || 'Unknown';
};

// Helper: extract US state abbreviation from location
export const getUserState = (location) => {
  if (!location) return '';
  if (location.state) return location.state;
  if (location.address) {
    const match = location.address.match(/,\s*([A-Z]{2})\s+\d{5}/);
    if (match) return match[1];
  }
  return '';
};

// Haversine formula: calculate distance in miles between two lat/lon points
export const haversineDistance = (lat1, lon1, lat2, lon2) => {
  const R = 3959; // Earth radius in miles
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLon / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};
